/* istanbul ignore file */

// This dummy URL is updated by a deploy script based on the environment. E.g.
// when deploying to production, CI replaces dev.www.v.me with
// secure.checkout.visa.com, but when deploying to cert, it will be
// cert.secure.checkout.visa.com.
export const STATIC_ROOT_DOMAIN = 'https://dev.www.v.me';

// START GENAI@GHCOPILOT
// TLPERF1-7407 - loosen regex to match both standard URI and SRI URIs.
// src-i-adapter folder
const sdkScriptRegex = /\/resources\/js\/src-i-adapter\/sdk\.js/;
// integration folder
const sdkScriptRegexIntegration = /\/resources\/js\/integration\/v2\/sdk\.js/;
const sdkScriptRegexCommunicator = /\/resources\/src\-system\/.*\.js/i;
// END GENAI@GHCOPILOT

function getSDKScriptEl() {
  const scripts = document.querySelectorAll('script');

  for (const script of scripts) {
    if (script.src.match(sdkScriptRegex) || script.src.match(sdkScriptRegexCommunicator)) {
      return script;
    } else if (script.src.match(sdkScriptRegexIntegration)) {
      return script;
    }
  }

  return null;
}

const assetsMap = {
  '//assets.secure.checkout.visa.com': '//secure.checkout.visa.com',
  '//cert-assets.secure.checkout.visa.com': '//cert.secure.checkout.visa.com',
  '//sandbox-assets.secure.checkout.visa.com': '//sandbox.secure.checkout.visa.com'
};

function mapAssetsUrl(url: string) {
  const assetDomains = Object.keys(assetsMap) as Array<keyof typeof assetsMap>;

  for (const assetDomain of assetDomains) {
    if (url.indexOf(assetDomain) !== -1) {
      return url.replace(assetDomain, assetsMap[assetDomain]);
    }
  }

  return url;
}

// Root domain is updated by a deploy script based on the environment. E.g.
// when deploying to production, CI replaces dev.www.v.me with
// secure.checkout.visa.com, but when deploying to cert, CI uses
// cert.secure.checkout.visa.com.
const dummyUrlHash = 'aHR0cHM6Ly9kZXYud3d3LnYubWU'; // btoa('https://dev.www.v.me')
const wasDummyUrlReplaced = STATIC_ROOT_DOMAIN !== window.atob(dummyUrlHash);

export default function getRootDomain() {
  if (wasDummyUrlReplaced) {
    return STATIC_ROOT_DOMAIN;
  }

  // In container deployments, the dummy url may not have been replaced. In this
  // case we need to determine the environment url from the visaSdk.js script tag.

  const sdkScriptEl = getSDKScriptEl();

  if (sdkScriptEl) {
    //eslint-disable-next-line
    console.log(`ROOT_DOMAIN: ${sdkScriptEl.src.split('/', 3).join('/')}`);
    return mapAssetsUrl(sdkScriptEl.src.split('/', 3).join('/'));
  }

  // Default to the prod URL for any abnormal integration.
  return 'https://secure.checkout.visa.com';
}
